import { render, staticRenderFns } from "./TagFilterChips.vue?vue&type=template&id=677ea889&scoped=true&"
import script from "./TagFilterChips.vue?vue&type=script&lang=js&"
export * from "./TagFilterChips.vue?vue&type=script&lang=js&"
import style0 from "./TagFilterChips.vue?vue&type=style&index=0&id=677ea889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ea889",
  null
  
)

export default component.exports